export const DEFAULT_USER = {
  id: '02de0e7d-201e-4602-80d8-8aae4e69faf5',
  username: 'admin',
  passwordSalt: '359f08f815b59a0fc1273ac56b2b7306',
  passwordHash:
    'f0c11592b579f5811349b032a4537802f4f587f28905add7dbce81ced7d7b001',
  createdAt: '2026-01-01T00:00:00.000Z',
};
